function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M48.62 10.62h-6c-4.73 0-5.62 2.27-5.62 5.54v7.27h11.23l-1.5 11.38H37V64H25.19V34.81h-9.81V23.42h9.81V15c0-9.73 6-15 14.65-15a75.12 75.12 0 018.77.46z",
  fill: "currentColor"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZmFjZWJvb2s8L3RpdGxlPjxwYXRoIGQ9Ik00OC42MiwxMC42MmgtNmMtNC43MywwLTUuNjIsMi4yNy01LjYyLDUuNTR2Ny4yN0g0OC4yM2wtMS41LDExLjM4SDM3VjY0SDI1LjE5VjM0LjgxSDE1LjM4VjIzLjQyaDkuODFWMTVjMC05LjczLDYtMTUsMTQuNjUtMTVhNzUuMTIsNzUuMTIsMCwwLDEsOC43Ny40NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgFacebook as ReactComponent };